const stamp = (date, time) => `${date.replace(/-/g, "")}T${time.replace(":", "")}00`;

const endOf = (e) => {
  if (e.end_time) return e.end_time;
  const [h, m] = e.start_time.split(":").map(Number);
  const t = h * 60 + m + 90;
  return `${String(Math.min(23, Math.floor(t / 60))).padStart(2, "0")}:${String(t >= 24 * 60 ? 59 : t % 60).padStart(2, "0")}`;
};

const esc = (s) => (s || "").replace(/[\\,;]/g, (c) => `\\${c}`).replace(/\n/g, "\\n");

export function downloadIcs(e, teamName) {
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//DiamondPlay//Team Schedule//EN", "BEGIN:VEVENT",
    `UID:${e.id}@diamondplay`, `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").split(".")[0]}Z`,
    `DTSTART:${stamp(e.date, e.start_time)}`, `DTEND:${stamp(e.date, endOf(e))}`,
    `SUMMARY:${esc(`${teamName}: ${e.title}`)}`, `LOCATION:${esc(e.location)}`, `DESCRIPTION:${esc(e.notes)}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${e.title.replace(/[^a-z0-9]+/gi, "-")}-${e.date}.ics`;
  a.click();
  URL.revokeObjectURL(url);
}

export const googleCalUrl = (e, teamName) =>
  `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(`${teamName}: ${e.title}`)}` +
  `&dates=${stamp(e.date, e.start_time)}/${stamp(e.date, endOf(e))}&location=${encodeURIComponent(e.location || "")}` +
  `&details=${encodeURIComponent(e.notes || "")}`;

export const localToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
